import { TLineSetupTicketSubtask, TLineSetupTicketSubtaskType } from '@monorepo/types';
import { ACCORDION_TABLE_MODIFIER } from '../../model/accordion-table.modifier';
import { TAccordion, TAccordionTableVM } from '../../model/accordion-table.types';
import { DatePipe } from '@angular/common';

const SUBTASK_TYPE_TO_DISPLAY_NAME: Record<TLineSetupTicketSubtaskType, string> = {
  ASSIGN_MACHINE: 'ASSIGN MACHINE',
  REMOVE_MACHINE: 'REMOVE MACHINE',
  REPLACE_MACHINE: 'REPLACE MACHINE',
};

const datePipe = new DatePipe('en-IN');

export const LINE_SETUP_TICKET_SUBTASKS_ACCORDION_TABLE_MODEL = {
  createModel(subtasks: TLineSetupTicketSubtask[], hasDeletePermission: boolean): TAccordionTableVM {
    return ACCORDION_TABLE_MODIFIER.createModel(
      [
        { label: 'tm_container_labels.WorkstationName', colSize: 9 },
        { label: 'tm_container_labels.Status', colSize: 7 },
        { label: 'tm_container_labels.Task', colSize: 7 },
      ],
      subtasks.map<TAccordion>((subtask) => ({
        id: subtask.id,
        isMinimized: true,
        rowItems: [
          { type: 'TEXT', value: subtask.workstationName },
          { type: 'TEXT', value: subtask.status },
          { type: 'TEXT', value: SUBTASK_TYPE_TO_DISPLAY_NAME[subtask.subTaskType] },
        ],
        moreInfo: [
          {
            items: [
              {
                label: 'tm_container_labels.MechanicName',
                size: 12,
                values: [{ displayName: subtask.assignedMechanic.name }],
              },
              {
                label: 'tm_container_labels.StartTime',
                size: 12,
                values: [{ displayName: (subtask.endTime && datePipe.transform(subtask.startTime, 'short')) ?? '- -' }],
              },
              {
                label: 'tm_container_labels.EndTime',
                size: 12,
                values: [{ displayName: (subtask.endTime && datePipe.transform(subtask.endTime, 'short')) ?? '- -' }],
              },
            ],
          },
        ],
        actions:
          subtask.status !== 'COMPLETED'
            ? [
                {
                  actionId: 'MARK_COMPLETE',
                  displayName: 'tm_common.Complete',
                },
                ...(hasDeletePermission
                  ? [
                      {
                        actionId: 'DELETE',
                        displayName: 'line_actions.Delete',
                      },
                    ]
                  : []),
              ]
            : [],
      })),
    );
  },
};
